var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "suc-radio-field-component",
        _vm._b(
          {
            attrs: {
              title: _vm.$t("pages.permission.absences.hours"),
              form: _vm.form,
              name: _vm.hourTypeName,
              options: _vm.options,
            },
            on: _vm._d({}, [_vm.changedHourTypeEvent, _vm.changedHourType]),
          },
          "suc-radio-field-component",
          _vm.$attrs,
          false
        )
      ),
      _vm.hasHourCustom && _vm.formOptionCustom
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("suc-select-component", {
                  attrs: {
                    form: _vm.form,
                    name: _vm.hourStartName,
                    options: _vm.customHours,
                    reduce: function (option) {
                      return option.value
                    },
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("suc-select-component", {
                  attrs: {
                    form: _vm.form,
                    name: _vm.hourEndName,
                    options: _vm.customHours,
                    reduce: function (option) {
                      return option.value
                    },
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }